import axios from 'axios';
import bugsnagClient from '@getaccept/lib-shared/src/bugsnag';
import type { SignupResponse } from '../types/signup-response';
import type { SignupPayload } from '../types/signup-payload';
import { useGoogleTagManager } from '../../common/composables/google-tag-manager.composable';

export default class SignupService {
  static async signup({
    email,
    registrationSource,
    recaptchaToken,
    registrationCampaign,
    language,
    templateId,
  }: SignupPayload): Promise<SignupResponse | undefined> {
    let response: SignupResponse | undefined = undefined;
    const signupComplete = function (data) {
      response = data;
    };

    const signupParams: URLSearchParams = new URLSearchParams({
      callback: signupComplete.name,
      'user-email': email,
      b_8ffc72b0378c08003ff1fae1f_37f364ae36: '',
      'user-registration-source': registrationSource,
      'user-language': language,
      'user-registration-campaign': registrationCampaign,
      'recaptcha-response': recaptchaToken,
    });

    if (templateId) {
      signupParams.append('template-id', templateId);
    }

    try {
      const { data, status } = await axios.get(`/signup/v2/create-user?${signupParams.toString()}`);
      if (status === 429) {
        response = { status: 5 };
      } else if (status === 400) {
        response = { status: 6 };
      } else {
        eval(data);
      }
    } catch (e) {
      if (bugsnagClient) {
        bugsnagClient.notify(e);
      }
      useGoogleTagManager().initiateSignupError({ error: e, email });
    }

    return response;
  }
}
